import { Button, ChakraProps, Icon } from '@chakra-ui/react';
import { IconType } from 'react-icons';

interface TableRowActionProps {
  label: string;
  icon: IconType;
  iconSx?: ChakraProps['sx'];
  onClick: () => void;
}

const TableRowAction: React.FC<TableRowActionProps> = ({ label, icon, iconSx, onClick }) => {
  return (
    <Button
      variant="ghost"
      color="rgba(0,0,0,0.6)"
      onClick={onClick}
      leftIcon={<Icon as={icon} color="gray.500" sx={iconSx} />}
    >
      {label}
    </Button>
  );
};

export default TableRowAction;
